export default __webpack_public_path__ + "static/mh-5c1193943a07cc82e6b19c19a2df2a7e.svg";